(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
if (!customElements.get("s-contact-us")) {
  customElements.define(
    "s-contact-us",
    class SectionContactUs extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.form = this.querySelector("form");

        if (this.form) {
          this.form.addEventListener("submit", this.validateForm);
          this.form.addEventListener("input", this.validateForm);
        }
      }

      disconnectedCallback() {
        if (this.form) {
          this.form.removeEventListener("submit", this.validateForm);
          this.form.removeEventListener("input", this.validateForm);
        }
      }

      validateForm = (event) => {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        let isValid = true;
        const setError = (input, hasError) => {
          if (hasError) {
            input.closest("label").style = "border-color: red";
            isValid = false;
          } else {
            input.closest("label").style = "";
          }
        };

        const nameInput = this.querySelector(".js-contact-us__input-name");
        setError(nameInput, !nameInput.value.trim() || /[^a-zA-Zа-яА-ЯёЁ\s]/.test(nameInput.value));

        const emailInput = this.querySelector(".js-contact-us__input-email");
        setError(emailInput, !emailInput.value.trim() || !/^[^<>"'%;)(&+]+@[^<>"'%;)(&+]+\.[a-z]{2,}$/.test(emailInput.value));

        const phoneInput = this.querySelector(".js-contact-us__input-tel");
        setError(phoneInput, !/^[+]?[0-9]{7,15}$/.test(phoneInput.value));

        const modelSelect = this.querySelector(".s-contact-us__select");
        if (modelSelect) {
          setError(modelSelect, !modelSelect.value.trim());
        }

        // const reasonInput = this.querySelector(".js-contact-us__input-text");
        // if (reasonInput) {
        //   setError(reasonInput, !reasonInput.value.trim() || /[<>"'%;)(&+]/.test(reasonInput.value));
        // }

        const messageTextarea = this.querySelector(".s-contact-us__textarea");
        setError(messageTextarea, !messageTextarea.value.trim() || /[<>"'%;)(&+]/.test(messageTextarea.value));

        if (isValid && event.type === "submit") this.form.submit();
      };
    }
  );
}
},{}]},{},[1])

